import React from 'react'

import { Pagination } from 'components'
import { onPageChange } from 'helpers/common'

import { ITicketSelectBranchPaginationProps } from './model'

function TicketSelectBranchPagination(
  props: ITicketSelectBranchPaginationProps,
): JSX.Element {
  const { currentPage, totalPage, disabled, setSearchParams } = props

  const base = 'f-ticket-bottom-con'

  const handlePageChange = (page: number) => {
    onPageChange(() => setSearchParams({ _page: page }))
  }

  return (
    <div className={base}>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPage}
        disabled={disabled}
        onChange={handlePageChange}
      />
    </div>
  )
}

export default TicketSelectBranchPagination
